module.exports = __webpack_public_path__ + "img/h_diamonds.11a33666.png";